import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/Main'
import Sub from '@/pages/Sub'
import Contents from '@/pages/Contents'
import Board from '@/pages/board/List'
import BoardView from '@/pages/board/View'
import BoardWrite from '@/pages/board/Write'
import OrderMain from '@/pages/order/Main'
import OrderCall from '@/pages/order/Call'
import OrderProgress from '@/pages/order/Progress'
import OrderHistory from '@/pages/order/History'
import Login from '@/pages/Login'
import Regist from '@/pages/member/Regist'
import RegistClass from "../pages/member/RegistClass.vue";
import RegistHC from "../pages/member/RegistHC.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/m',
      alias: '/',
      name: 'Main',
      component: Main
    },    
    {
      path: '/m/sub/:c_no',
      name: 'Sub',
      component: Sub
    },
    {
      path: '/m/contents/:contents_no',
      name: 'Contents',
      component: Contents
    },
    {
      path: '/m/board/:c_no',
      name: 'Board',
      component: Board
    },
    {
      path: '/m/board/view/:c_no/:b_c_no',      
      name: 'BoardView',
      component: BoardView
    },
    {
      path: '/m/board/write/:c_no',
      name: 'BoardWrite',
      component: BoardWrite      
    },
    {
      path: '/m/order/main',
      name: 'OrderMain',
      component: OrderMain
    },
    {
      path: '/m/order/call',
      name: 'OrderCall',
      component: OrderCall
    },
    {
      path: '/m/order/progress',
      name: 'OrderProgress',
      component: OrderProgress
    },
    {
      path: '/m/order/history',
      name: 'OrderHistory',
      component: OrderHistory
    },
    {
      path: '/m/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/m/member/regist',
      name: 'RegistForm',
      component: Regist
    },
    {
      path: '/m/member/registClass',
      name: 'RegistClass',
      component: RegistClass
    },
    {
      path: '/m/member/registHC',
      name: 'RegistHCForm',
      component: RegistHC
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js